"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _glCore = require("@capture/gl-core");

class ShapeDrawPointsFilter extends _glCore.GLFilter {
  constructor() {
    const vsSource = `
        attribute highp vec2 a_pos;
        attribute highp float a_size;
        attribute highp float a_draw;
        varying highp float v_draw;
        void main() {
            gl_Position = vec4(a_pos, 0.0, 1.0);
            gl_PointSize = a_size;
            v_draw = a_draw;
        }
        `;
    const fsSource = `
        varying highp float v_draw;
        void main() {
            gl_FragColor = v_draw > 0.5 ? vec4(vec3(0.0), 1.0) : vec4(1.0);
        }
        `;
    super(fsSource, vsSource);
    this.isDrawMode = false;
    this.points = [];
    this._prevPoints = [];
  }

  draw(gl, texture, flip, blend) {
    if (this.points.length / 4 <= 0) {
      return;
    }

    gl.viewport(0, 0, this._viewWidth, this._viewHeight);

    if (blend) {
      gl.enable(gl.BLEND);
      gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ZERO, gl.ONE);
    } else {
      gl.clearColor(1.0, 0.0, 0.0, 1.0);
      gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
    }

    gl.useProgram(this.program);
    gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
    gl.vertexAttribPointer(this.attribLocations.aPos, 2, gl.FLOAT, false, 4 * Float32Array.BYTES_PER_ELEMENT, 0);
    gl.enableVertexAttribArray(this.attribLocations.aPos);
    gl.vertexAttribPointer(this.attribLocations.aDraw, 1, gl.FLOAT, false, 4 * Float32Array.BYTES_PER_ELEMENT, 2 * Float32Array.BYTES_PER_ELEMENT);
    gl.enableVertexAttribArray(this.attribLocations.aDraw);
    gl.vertexAttribPointer(this.attribLocations.aSize, 1, gl.FLOAT, false, 4 * Float32Array.BYTES_PER_ELEMENT, 3 * Float32Array.BYTES_PER_ELEMENT);
    gl.enableVertexAttribArray(this.attribLocations.aSize);

    if (this.points.length !== this._prevPoints.length) {
      this._prevPoints = this.points.slice();

      for (let i = 3; i < this._prevPoints.length; i += 4) {
        this._prevPoints[i] = this._prevPoints[i] * Math.min(this._viewWidth, this._viewHeight);
      }

      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(this._prevPoints), gl.STATIC_DRAW);
    }

    gl.drawArrays(gl.POINTS, 0, this._prevPoints.length / 4);

    if (blend) {
      gl.disable(gl.BLEND);
    }
  }

  initAttribLocations(gl, program) {
    return {
      aPos: gl.getAttribLocation(program, 'a_pos'),
      aDraw: gl.getAttribLocation(program, 'a_draw'),
      aSize: gl.getAttribLocation(program, 'a_size')
    };
  }

  initBuffer(gl) {
    this._prevPoints = [];
    const buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(this.points), gl.STATIC_DRAW);
    return buffer;
  }

}

exports.default = ShapeDrawPointsFilter;